<template>
    <div class="container">
        <div class="backroute" @click.stop="router.push(`/course/${route.params.courseId}/module/${route.params.moduleId}/forum/${route.params.contentId}`)"><i class="material-icons">keyboard_arrow_left</i><span>Volver</span></div>

        <template v-if="dataLoaded">
            <h3>{{ $t('forum.history.DETAIL_TITLE') }}</h3>
            <div class="user-info tutor__infoCard">
                <span class="user-info__name"><strong>{{ $t('global.PARTICIPANT') }}: </strong>{{userData.userInfo.firstName}} {{userData.userInfo.lastName}}</span>
                <div class="user-info__status">
                    <strong>{{$t('global.STATUS')}}:</strong>
                    <span :class="{'NotFinished--a': userData.userInfo.status == 'NotFinished', 'FinishedOutOfTime--a': userData.userInfo.status === 'FinishedOutOfTime', 'FinishedInTime--a': userData.userInfo.status === 'FinishedInTime'}">
                        {{$t(`tutor.detail.status.${userData.userInfo.status}`)}}
                    </span>
                    <span v-if="userData.userInfo.status == 'NotFinished'">
                        {{userData.userInfo.timeDiffValue ? $t('global.EXPIRES_IN') + userData.userInfo.timeDiffValue + ' ' + $t(`date.params.${userData.userInfo.timeDiffParam}`) : $t('global.EXPIRED')}}
                    </span>
                    <span v-if="userData.userInfo.status == 'FinishedOutOfTime'">
                        {{userData.userInfo.timeDiffValue + ' ' + $t(`date.params.${userData.userInfo.timeDiffParam}`) + + ' ' + $t('global.LATE')}}
                    </span>
                </div> 

                <span class="user-info__mail" ><strong>{{$t('global.EMAIL')}}: </strong>{{userData.userInfo.email}}</span>
                <div><span><strong>{{ $t('global.LAST_MODIFICATION') }}: </strong></span><span>{{userData.userInfo.lastSeen ? formatDate(userData.userInfo.lastSeen) : $t('global.NEVER')}}</span></div>
            </div>

            <h3>{{$t('forum.history.COMMENT_HISTORY')}}</h3>

            <div class="history" v-if="userData.headers.length > 0">
                <div class="forum tutor__infoCard" v-for="(header, headerIdx) in userData.headers" :key="headerIdx">
                    <div class="forum__header ">
                        <div>{{$t('global.DEBATE')}} : </div>
                        <div>
                            <span class="subject">{{header.subject}}</span>
                            <!-- <span class="message">{{header.message}}</span> -->
                            <div v-if="header.message" v-html="header.message"></div>
                        </div>
                    </div>

                    <div class="forum__comments">
                        <div class="comment" v-for="(comment, commentIdx) in header.comments" :key="commentIdx">
                            <span class="comment__date">Comentó el {{formatDate(comment.createdDate)}}</span>
                            <div class="comment__comment" v-html="comment.comment"></div>
                            <div class="comment__files">
                                <a v-for="(file,fileIdx) in comment.attach" :key="fileIdx" :href="getFile(file.file,'activity')" target="_blank">
                                    <i class="material-icons">attach_file</i>
                                    <span>{{file.originalFileName}}</span>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div v-else>{{$t('global.WITHOUT_ACTIVITY')}}</div>
        </template>

    </div>
</template>
<script>
import { useRoute, useRouter } from 'vue-router';
import { onMounted, ref, inject, computed } from 'vue';
import { useStore } from 'vuex';
import { VueEditor, Quill } from "vue3-editor";
import Emoji from "quill-emoji/dist/quill-emoji";
Quill.register("modules/emoji", Emoji);

export default {
    setup() {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const formatDate = inject("formatDate");
        const getFile = inject("getFile");
        const userData = ref();
        const dataLoaded = ref(false);
        const user = computed(() => store.getters.manageUser_user);


        async function getUserData(){
            try {
                let req = await store.dispatch('activities_forumUserHistory',{ contentId: route.params.contentId, userId: route.params.userId })
                userData.value = req.data;
                dataLoaded.value = true;
            } catch (error) {
                console.log(error)
            }
        }


        onMounted(() => {
            if (!user.value.permissions.includes('CURSO_ACTIVIDAD_DETALLE')) return
            getUserData();
        })

        return{
            route,
            router,
            formatDate,
            getFile,
            userData,
            dataLoaded,
            VueEditor
        }
    },
}
</script>

<style src="quill-emoji/dist/quill-emoji.css"></style>
<style lang="scss" scoped>
@import '@/styles/main.scss';

.backroute{
    margin-bottom: 24px;
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 2px;
    color: $green;
    font-size: 13px; 
    font-weight: 600;
    cursor: pointer;
    .material-icons{
        font-size: 18px;
    }
}

.user-info{
    width: 100%;
    padding: 16px;
    margin-bottom: 32px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 24px;
    background: #fff;
    border-radius: 8px;
    color: $black;
    font-size: 14px;
    font-weight: 400;
    @media screen and (max-width: $bpBig){
        flex-direction: column;
        align-items: flex-start;
        font-size: 11px;
    }
    &__name{
        width: 50%;
        @media screen and (max-width: $bpMedium){
            width: 100%;
        }
    }
    &__mail{
        width: 50%;
        @media screen and (max-width: $bpMedium){
            width: 100%;
        }
    }
    &__status{
    display: flex;
    align-items: center;
    gap: 6px;
    span:last-child{
        font-weight: 400;
        font-size: 12px;
        color: $darkgray;
        @media screen and (max-width: $bpBig){
            font-size: 9px;
        }   
    }
}
}
h3{
    font-weight: 600;
    font-size: 18px;
    color: $black;
    margin: 12px 0;
    @media screen and (max-width: $bpSmall){
        font-size: 16px;
    }
}
.history{
    width: 100%;
    @include flex-column;
    gap: 16px;
    .forum{
        width: 100%;
        @include flex-column;
        background: #fff;
        border-radius: 8px;
        >*{
            width: 100%;
        }
        &__header{
            padding-top: 12px;
            display: flex;
            align-items: center;
            color: $black;
            >div:first-child{
                width: fit-content;
                padding-left: 32px;
                padding-right: 52px;
                font-size: 18px;
                font-weight: 600;
                @media screen and (max-width: $bpSmall) {
                    font-size: 14px;
                    padding-left: 24px;
                    padding-right: 32px;
                }
            }
            >div:last-child{
                flex-grow: 1;
                @include flex-column;
                align-items: flex-start;
                gap: 8px;
                >span{
                    width: 100%;
                    font-size: 16px;
                }
                .subject{
                    font-weight: 600;
                    @media screen and (max-width: $bpSmall){
                        font-size: 12px;
                    }
                }
            }
        }
        &__comments{
            padding: 16px;
            display: flex;
            flex-direction: column;
            //flex-wrap: wrap;
            gap: 12px;
            .comment{
                width: 100%;
                //min-width: 260px;
                height: fit-content;
                padding: 8px;
                border-radius: 8px;
                background: $lightgray;
                >*{
                    width: 100%;
                }
                &__date{
                    font-size: 12px;
                    font-weight: 600;
                }
                &__comment{
                    padding: 8px 4px;
                    font-size: 14px;
                    color: $black;
                }
                &__files{
                    display: flex;
                    flex-wrap: wrap;
                    gap: 12px;
                    a{
                        padding: 4px 12px;
                        padding-left: 8px;
                        display: flex;
                        align-items: center;
                        background: $green;
                        color: #fff;
                        border-radius: 16px;
                        i{
                            font-size: 17px;
                        }
                        span{
                            text-decoration: underline;
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
}

</style>